import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import TempCustomer from "../../../containers/modules/master/customer-temp";

export default function CustomerTempRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="customer-temp"
      index
      element={
        <AccessControl
          name={"Temperory Customer List"}
          auth={authUser}
          component={() => <TempCustomer />}
        />
      }
    />
  );
}
